import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/public/Home";
import Products from "@/pages/public/Products";
import HowItWorks from "@/pages/public/HowItWorks";
import RequestFuel from "@/pages/public/RequestFuel";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import QuotationView from "@/pages/QuotationView";

import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import CustomerOrderDetail from "@/pages/customer/CustomerOrderDetail";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCustomerDetail from "@/pages/admin/AdminCustomerDetail";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAudit from "@/pages/admin/AdminAudit";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/request-fuel" element={<RequestFuel />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/q/:token" element={<QuotationView />} />

            <Route path="/portal" element={<ProtectedRoute roles={["customer"]}><CustomerDashboard /></ProtectedRoute>} />
            <Route path="/portal/orders/:id" element={<ProtectedRoute roles={["customer"]}><CustomerOrderDetail /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/orders" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminOrders /></ProtectedRoute>} />
            <Route path="/admin/orders/:id" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminOrderDetail /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminCustomers /></ProtectedRoute>} />
            <Route path="/admin/customers/:id" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminCustomerDetail /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute roles={["admin", "finance", "operations"]}><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute roles={["admin", "finance"]}><AdminAudit /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
